import { Link } from "react-router-dom";

const FB = "https://www.facebook.com/profile.php?id=61567252557995";
const IG = "https://www.instagram.com/akimart766/";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-glow" aria-hidden="true" />
      <div className="container footer-grid">
        <div className="footer-brand">
          <Link className="brand" to="/">
            <img className="brand-mark" src="/ethiopian-flag.svg" alt="" width="32" height="32" />
            <span className="brand-text">Aki Mart</span>
          </Link>
          <p>
            Habesha staples for the diaspora — fresh injera, dabo, hambasha, roasted snacks,
            and handmade clothing from our Lilburn, Georgia market.
          </p>
          <div className="social-row footer-social">
            <a className="social-link" href={FB} target="_blank" rel="noreferrer">
              Facebook
            </a>
            <a className="social-link" href={IG} target="_blank" rel="noreferrer">
              Instagram
            </a>
          </div>
        </div>
        <div>
          <h3>Explore</h3>
          <ul className="footer-links">
            <li>
              <Link to="/shop">All products</Link>
            </li>
            <li>
              <Link to="/shop?category=bread">Injera &amp; bread</Link>
            </li>
            <li>
              <Link to="/shop?category=clothing">Habesha dresses</Link>
            </li>
            <li>
              <Link to="/contact">Visit us</Link>
            </li>
          </ul>
        </div>
        <div>
          <h3>Visit</h3>
          <address>
            1025 Killian Hill Rd
            <br />
            Lilburn GA, 30047 Suite C
            <br />
            <a href="tel:+14044536512">+1 (404) 453-6512</a>
          </address>
        </div>
      </div>
      <div className="footer-bottom container">
        <p>© {new Date().getFullYear()} Aki Mart. All rights reserved.</p>
        <span>Serving Habesha families across metro Atlanta</span>
      </div>
    </footer>
  );
}
